import { useState, useEffect } from 'react';
import { Header } from '../../../common/Header/Header.jsx';
import { useParams, useHistory } from 'react-router-dom';
import { membershipService } from '../../../../services/membershipService.js';
import { notify } from '../../../../assets/helpers/toast.js';
import { OrderCard } from './OrderComponents.jsx';
import { ChangePaymentCard } from './ChangePaymentCard.jsx';
import {
  renameMembershipStatus,
  capitalize,
} from '../../../../assets/helpers/funciones.js';
import { paymentType as paymenTypeEnum } from '../../../../assets/helpers/options.js';
import './Order.scss';

export const ChangePayment = () => {
  const { membershipId } = useParams();
  const [membership, setMembership] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const { paymentTypeURL } = useParams();
  const history = useHistory();

  const validateURL = () => {
    const capitalizedURL = capitalize(paymentTypeURL).replace(/-/g, ' ');
    if (!Object.values(paymenTypeEnum).includes(capitalizedURL)) {
      history.push('/error');
    } else {
      setPaymentType(capitalizedURL);
    }
  };

  const getSalesMembershipById = (membershipId) => {
    membershipService
      .getSalesMembershipById(membershipId)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setMembership(response?.data);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch((error) => {});
  };

  const reloadMembership = () => {
    getSalesMembershipById(membershipId);
  };

  useEffect(() => {
    validateURL();
    getSalesMembershipById(membershipId);
  }, []);

  // Validate if the URL param is a permited paymentType

  return (
    <>
      <Header />
      {membership && (
        <div className="service-with-container container">
          <h1 className="title-component">
            Cambio de pago {membership?.membershipId} (
            {renameMembershipStatus(membership?.membershipStatus)})
          </h1>
          <div className="breadcrumb-container"></div>
          <div className="filter-button-container"></div>
          <br />
          <div className="row">
            <div className="col-12 col-lg-9">
              <ChangePaymentCard
                label={'INFORMACIÓN DE PAGO'}
                membership={membership}
                reloadMembership={reloadMembership}
                paymentType={paymentType}
              />
            </div>
            <div className="col-12 col-lg-3">
              <OrderCard
                membership={membership}
                refresh={() => getSalesMembershipById(membershipId)}
                hideCancelButton={true}
                isFromChangePaymentType={true}
              />{' '}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
